/**
 * Minimum characters required before the regular search auto-fires on
 * keystroke. Below this we keep the bar in its idle / recents state so
 * stray 1- or 2-character typing doesn't hammer the multi-source pipeline.
 */
export const REGULAR_TYPEAHEAD_MIN_LENGTH = 3;

/**
 * Debounce delay between the last keystroke and the auto-fired search.
 * Sized to absorb a normal typing burst without firing per-keystroke.
 */
export const REGULAR_TYPEAHEAD_DEBOUNCE_MS = 500;

export function shouldRunRegularTypeahead(input: string): boolean {
  return (
    !input.startsWith('/') &&
    input.trim().length >= REGULAR_TYPEAHEAD_MIN_LENGTH
  );
}
